export enum TaxDocumentType {
  SUPPORTING_DOCS = 'SUPPORTING_DOCS',
  TAX_RETURN = 'TAX_RETURN',
  SIGNED_FORMS = 'SIGNED_FORMS',
  NOA = 'NOA',
  OTHER_ATO_DOCS = 'OTHER_ATO_DOCS',
  DEPRECIATION_SCHEDULE = 'DEPRECIATION_SCHEDULE',
  SIGNED_AGREEMENTS = 'SIGNED_AGREEMENTS',
  OTHER_DOCS = 'OTHER_DOCS',
  UNKNOWN = 'UNKNOWN',
}

export enum TaxSupportingDocsSubType {
  RENTAL_STATEMENTS = 'RENTAL_STATEMENTS',
  LOAN_STATEMENTS = 'LOAN_STATEMENTS',
  ATO_DOCUMENTS = 'ATO_DOCUMENTS',
  CGT_RELATED_ITEMS = 'CGT_RELATED_ITEMS',
  COUNCIL_RATES = 'COUNCIL_RATES',
  WATER_RATES = 'WATER_RATES',
  INSURANCE = 'INSURANCE',
  PROPERTY_AGENT_FEES = 'PROPERTY_AGENT_FEES',
  BODY_CORP = 'BODY_CORP',
  LAND_TAX = 'LAND_TAX',
  CLEANING = 'CLEANING',
  ADVERTISING_FOR_TENANTS = 'ADVERTISING_FOR_TENANTS',
  REPAIRS_AND_MAINTENANCE = 'REPAIRS_AND_MAINTENANCE',
  OTHER_PROPERTY_EXPENSE = 'OTHER_PROPERTY_EXPENSE',
  INDIVIDUAL_SHARES = 'INDIVIDUAL_SHARES',
  OTHERS = 'OTHERS',
  UNKNOWN = 'UNKNOWN',
}

export const DOC_TYPE_LABELS: Record<TaxDocumentType, string> = {
  SUPPORTING_DOCS: 'Supporting Docs',
  TAX_RETURN: 'Tax Return',
  SIGNED_FORMS: 'Signed Forms',
  NOA: 'NOA',
  OTHER_ATO_DOCS: 'Other ATO Docs',
  DEPRECIATION_SCHEDULE: 'Depreciation Schedule',
  SIGNED_AGREEMENTS: 'Signed Agreements',
  OTHER_DOCS: 'Other Docs',
  UNKNOWN: 'Unknown',
};

export const SUB_TYPE_LABELS: Record<TaxSupportingDocsSubType, string> = {
  RENTAL_STATEMENTS: 'Rental Statements',
  LOAN_STATEMENTS: 'Loan Statements',
  ATO_DOCUMENTS: 'ATO Documents',
  CGT_RELATED_ITEMS: 'CGT Related Items',
  COUNCIL_RATES: 'Council Rates',
  WATER_RATES: 'Water Rates',
  INSURANCE: 'Insurance',
  INDIVIDUAL_SHARES: 'Individual Shares',
  PROPERTY_AGENT_FEES: 'Property Agent Fees',
  BODY_CORP: 'Body Corp',
  LAND_TAX: 'Land Tax',
  CLEANING: 'Cleaning',
  ADVERTISING_FOR_TENANTS: 'Advertising for Tenants',
  REPAIRS_AND_MAINTENANCE: 'Repairs & Maintenance',
  OTHER_PROPERTY_EXPENSE: 'Other Property Expenses',
  OTHERS: 'Other Individual Income / Expenses',
  UNKNOWN: 'Unknown',
};
